export default __webpack_public_path__ + "static/media/coursera-logo.c0871dd5.jpg";